import { Grid } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import {
  createGetOverviewOptions,
  createGetOverviewStepsOptions,
} from '../../queries/overviewQueries';
import { createGetUserSite } from '../../queries/userQueries';
import { TrackingInfo } from '../../styles';
import CostImpact from '../SummaryPage/CostImpact';
import TrackingFileDetailsFilter from './TrackingFileDetailsFilter';
import TrackingFileDrivers from './TrackingFileDrivers';
import TrackingFileSummary from './TrackingFileSummary';
import TrackingFileTable from './TrackingFileTable';
import ValueAndEffort from './ValueAndEffort';

function TrackingFilePage() {
  const [searchParams] = useSearchParams();
  const pecrId = searchParams.get('id');
  const { t } = useTranslation();
  const userInfo = useSelector(state => state.userInfo);

  const { data, isLoading, error } = useQuery(
    createGetOverviewOptions({ pecrId }, { enabled: !!pecrId })
  );
  const { data: userSiteData, error: userSiteError } = useQuery(
    createGetUserSite({ userId: data?.UserID }, { enabled: !!data?.UserID })
  );
  const { data: reviewData } = useQuery(
    createGetOverviewStepsOptions({ pecrId }, { enabled: !!pecrId })
  );
  if (error) {
    console.error('Error fetching overview data:', error);
  }
  if (userSiteError) {
    console.error('Error fetching user site data:', userSiteError);
  }
  let siteId;
  const groupedData =
    reviewData && Object.groupBy(reviewData, item => item.SiteID);
  const sites = groupedData ? Object.keys(groupedData) : [];
  if (reviewData && reviewData.length > 0) {
    const creatorStep = reviewData.find(item => item.Step === 'Creator');
    if (creatorStep) {
      siteId = creatorStep.SiteID;
    }
  }
  return (
    <Grid style={TrackingInfo}>
      {data && userSiteData && (
        <TrackingFileSummary
          data={data}
          userSiteData={userSiteData}
          isLoading={isLoading}
        />
      )}
      {data && <TrackingFileDrivers data={data} />}
      <ValueAndEffort title={t('VEScoring')} />
      <TrackingFileDetailsFilter />
      {pecrId && sites.includes(userInfo.siteID) && (
        <CostImpact
          key={userInfo.siteID}
          pecrId={pecrId}
          siteId={userInfo.siteID}
        />
      )}
      <TrackingFileTable />
    </Grid>
  );
}

export default TrackingFilePage;
